<template>
    <v-content class="page_premio">
        <Stepper :index="indexStepbar" class="stepperBar"></Stepper>
        <PremioBody/>
    </v-content>
</template>

<script>
    import Stepper from "@/components/partials/Stepper";
    import PremioBody from "@/components/mps/Premio_body";
    import {mapMutations, mapGetters} from "vuex";

    export default {
        name: "premio",
        components: {
            PremioBody,
            Stepper
        },
        data() {
            return {
                isNext: this.$route.params.isNext,
                idSession: sessionStorage.getItem('sessionId'),
            };
        },
        created() {
            this.setIndex(3);
        },
        head: {
            title: {
                inner: 'La quotazione per voi'
            },
            script: [
                {
                    type: 'text/javascript',
                    src: process.env.VUE_APP_URL_AXA1,
                },
                {
                    type: 'text/javascript',
                    inner: 'if (typeof tc_events_global === "function") { \n' +
                           '    tc_events_global(this, "virtual_page", {});\n' +
                           '}'
                },
            ],
            noscript: [{
                src: '//redirect4708.tagcommander.com/utils/noscript.php?id=1&amp;amp;mode=iframe',
                width: '1',
                height: '1',
                rel: 'noindex,nofollow',
            }],
        },
        beforeMount(){
            window['tc_vars'] = {
                env_template: "AXA_PerNoi",
                env_work: process.env.VUE_APP_TRK_ENV,
                env_channel: channel,
                user_category: this.getCustomerTypeTrk,
                page_name: "Step5",
                user_id: sessionStorage.getItem('sessionId'),
            };
        },
        methods: {
            ...mapMutations({
                setIndex: "stepper/setIndex"
            })
        },
        computed: {
            ...mapGetters({
                indexStepbar: "stepper/getIndex",
                getCustomerTypeTrk: 'params/getCustomerTypeTrk',
            })
        },
    };
</script>
